<template>
  <div id="header__controls" class="header-controls">
    <b-modal centered hide-footer id="feedbackModal" title="Send Feedback">
      <FeedbackModal ref="refFeedbackModal" />
    </b-modal>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-7 col-md-8 col-8 left-side">
          <div class="form-inline">
            <div class="input-group top-search">
              <input
                type="text"
                class="form-control media-calls-search"
                v-model="searchQuery"
                v-debounce:500ms="setQuery"
                :debounce-events="['keyup']"
                placeholder="Search audit logs..."
                @click="$refs.searchQuery.select()"
                @keypress.enter="getAuditLogs()"
                ref="searchQuery"
                id="search-query"
              />
              <div class="input-group-append cursor-pointer" @click="getAuditLogs()">
                <span class="input-group-text">
                  <i class="fas fa-search"></i>
                </span>
              </div>
            </div>
            <div class="report-type audit-log-user">
              <multiselect
                ref="auditLogUser"
                v-model="filterQuery.coordinator"
                :options="allUsers"
                :show-labels="false"
                :multiple="true"
                :allow-empty="false"
                placeholder="Filter by user"
                track-by="id"
                label="name"
                open-direction="bottom"
              >
                <template slot="selection" slot-scope="{ values, search, isOpen }">
                  <span
                    class="multiselect__single"
                    v-if="values.length && !isOpen"
                  >{{ values.length }} options selected</span>
                </template>
              </multiselect>
            </div>

            <div class="btn-group add-new__global_search">
              <b-button @keydown.esc="$refs.ALCreatedDatePopover.$emit('close')" class="ml-2 header-filter-btns" variant="theme" @click="ALCreatedDatePopover = !ALCreatedDatePopover" ref="ALCreatedDate" id="ALCreatedDate">
                Created Date
                <i class="far fa-calendar-check text-primary"></i>
              </b-button>
              <b-popover 
                ref="ALCreatedDatePopover"
                :show.sync="ALCreatedDatePopover" 
                target="ALCreatedDate" 
                triggers="click blur" 
                placement="bottom"
                custom-class="filter_popover__gs created-date-popover">
                <date-range-picker
                  ref="pickerDateCreated"
                  opens='inline'
                  @update="onUpdateDateCreated"
                  :autoApply="true"
                  :ranges="customCreatedDateRanges"
                  v-model="filterQuery.dateCreatedRange"
                ></date-range-picker>
              </b-popover>
            </div>
            
            <b-form-group>
              <div v-if="isMobile()" class="mobile__date__triggers">
                <multiselect
                  ref="dateFilterTrigger"
                  v-model="triggerSelected"
                  :options="dateTriggers"
                  :show-labels="false"
                  :multiple="false"
                  :allow-empty="false"
                  @input="setDateTriggerMobile"
                  open-direction="bottom"
                >
                </multiselect>
              </div>
              <div v-if="!isMobile()">
                <label class="btn-theme date-filter-triggers">
                  <b-form-radio
                    ref="today"
                    v-model="triggerSelected"
                    class="csm-checkbox"
                    id="today"
                    value="today"
                    name="createdDateTrigger"
                    @change="filterQuery.filterByDateCreated = true; filterQuery.dateCreatedRange.startDate = $moment().format(); filterQuery.dateCreatedRange.endDate = $moment().format();"
                  >
                    Today
                  </b-form-radio>
                </label>
                <label class="btn-theme ml-2 date-filter-triggers">
                  <b-form-radio
                    ref="weekly"
                    v-model="triggerSelected"
                    class="csm-checkbox"
                    id="weekly"
                    value="weekly"
                    name="createdDateTrigger"
                    @change="filterQuery.filterByDateCreated = true; filterQuery.dateCreatedRange.startDate = $moment().startOf('week').format(); filterQuery.dateCreatedRange.endDate = $moment().endOf('week').format();"
                  >
                    This Week
                  </b-form-radio>
                </label>
              </div>
            </b-form-group>
            <!-- <div
              class="ml-2 expand-grp cursor-pointer"
              @click="expandAll = !expandAll; $root.$emit('toggle-all-audit-logs', expandAll)"
            >
              <b-button
                class="header-filter-btns expand-ctrls"
                :class="{'none-active-btn': expandAll}"
                variant="theme"
                v-b-tooltip.hover
                title="Expand"
              >
                <span class="text">Expand All </span>
                <span class="icon"><i class="fas text-primary fa-expand fa-fw"></i></span>
              </b-button>
              <b-button
                class="header-filter-btns expand-ctrls"
                :class="{'none-active-btn': !expandAll}"
                variant="theme"
                v-b-tooltip.hover
                title="Collapse"
              >
                <span class="text">Collapse All</span>
                <span class="icon"><i class="fas text-primary fa-compress fa-fw"></i></span>
              </b-button>
            </div> -->
            
            <div class="ml-2">
              <FeedbackBtn />
            </div>
          </div>
          <div
            class="mt-3"
            v-if="isFilterActive()"
          >
            <label class="remove-filter-text">Click to remove filters:</label>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="filterQuery.query = ''; searchQuery = ''"
              :style="{cursor: 'pointer'}"
            >{{ filterQuery.query }}</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter(coordinator)"
              :style="{cursor: 'pointer'}"
              v-for="coordinator in filterQuery.coordinator"
            >{{ coordinator.name }}</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter('filterByDateCreated')"
              :style="{cursor: 'pointer'}"
              v-if="filterQuery.filterByDateCreated"
            >Created: {{ filterQuery.dateCreatedRange.startDate | moment('MMM DD') }} - {{ filterQuery.dateCreatedRange.endDate | moment('MMM DD') }}</span>
          </div>
        </div>
        <div class="col-sm-5 col-md-4 col-4 text-right right-side">
          <div class="logo-user">
            <HeaderNotification />
            <LoggedInUser />
            <Logo />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Logo from "./Logo";
import LoggedInUser from "./LoggedInUser";
import HeaderNotification from "./HeaderNotification";
import FeedbackBtn from "./FeedbackBtn";
import FeedbackModal from "./FeedbackModal";
import router from "../../routes";
import toast from "../../toast";

export default {
  data() {
    return {
      triggerSelected: false,
      dateTriggers: [
        'today', 'weekly'
      ],
      customCreatedDateRanges: {
        'Yesterday': [this.$moment().subtract(1, 'days').toDate(), this.$moment().subtract(1, 'days').toDate()],
        'Last week': [this.$moment().subtract(7, 'days').startOf('week').toDate(), this.$moment().subtract(7, 'days').endOf('week').toDate()],
        'Last two week': [this.$moment().subtract(14, 'days').startOf('week').toDate(), this.$moment().subtract(7, 'days').endOf('week').toDate()],
        'Today': [this.$moment().toDate(), this.$moment().toDate()],
        'This week': [this.$moment().startOf('week').toDate(), this.$moment().endOf('week').toDate()]
      },
      searchQuery: '',
      filterQuery: {},
      expandAll: true,
      ALCreatedDatePopover: false
    };
  },
  components: {
    Logo,
    LoggedInUser,
    FeedbackBtn,
    FeedbackModal,
    HeaderNotification
  },
  computed: {
    ...mapGetters(["allCustomFields", "allUsers", "userAbilities", "auditLogFilter"]),
  },
  mounted() {
    // hiding the header logo when scrolling in mobile
    if(this.isMobile() && this.$store.getters.isLoggedIn) {
      var prevScrollpos = window.pageYOffset;
      window.onscroll = function() {
        var currentScrollPos = window.pageYOffset;
        if (prevScrollpos > currentScrollPos) {
          document.getElementById("header__controls").style.top = "0";
        } else {
          document.getElementById("header__controls").style.top = "-60px";
        }
        prevScrollpos = currentScrollPos;
      }
    }
    this.fetchAllCustomFields();
    this.fetchUsers();
    this.filterQuery = this.auditLogFilter;
    if(this.isMobile()) {
      this.triggerSelected = 'weekly';
      this.filterQuery.filterByDateCreated = true; 
      this.filterQuery.dateCreatedRange.startDate = this.$moment().startOf('week').format(); 
      this.filterQuery.dateCreatedRange.endDate = this.$moment().endOf('week').format();
    } else {
      $('#weekly').trigger('click');
    }
    if(!this.filterQuery.filterByDateCreated) {
      this.filterQuery.dateCreatedRange = {
        startDate: new Date(),
        endDate: new Date()
      }
    }
  },
  methods: {
    ...mapActions([
      'fetchAllCustomFields',
      'fetchUsers'
    ]),
    isFilterActive() {
      return this.filterQuery.query != '' || this.filterQuery.filterByDateCreated || this.filterQuery.coordinator.length;
    },
    setDateTriggerMobile() {
      if(this.triggerSelected == 'weekly') {
        this.filterQuery.filterByDateCreated = true; 
        this.filterQuery.dateCreatedRange.startDate = this.$moment().subtract(7, 'days').startOf('week').format(); 
        this.filterQuery.dateCreatedRange.endDate = this.$moment().subtract(7, 'days').endOf('week').format();
      } else if(this.triggerSelected == 'today') {
        this.filterQuery.filterByDateCreated = true; 
        this.filterQuery.dateCreatedRange.startDate = this.$moment().format(); 
        this.filterQuery.dateCreatedRange.endDate = this.$moment().format();
      }
    },
    setQuery() {
      this.filterQuery.query = this.searchQuery
    },
    onUpdateDateCreated() {
      this.triggerSelected = false;
      this.filterQuery.filterByDateCreated = true;
      this.focusFilterBtn();
    },
    resetFilter() {
      this.triggerSelected = false;
      this.filterQuery.query = "";
      this.searchQuery = "";

      this.filterQuery.filterByDateCreated = false;
      this.filterQuery.dateCreatedRange = {
        startDate: new Date(),
        endDate: new Date()
      };
    },
    removeFilter(data) {
      if (typeof data != "undefined") {
      	if (typeof data == "string") {
          if (data == "filterByDateCreated") {
            this.triggerSelected = false;
            this.filterQuery.filterByDateCreated = false;
            this.filterQuery.dateCreatedRange.startDate = new Date();
            this.filterQuery.dateCreatedRange.endDate = new Date();
          }
      	} else {
          this.filterQuery.coordinator = this.filterQuery.coordinator.filter(
            (s) => {
              return s.name != data.name;
            }
          );
        };
      } else {
      		// TODO:  Check if a filter can be anything other than a string or object.
      }
    },
    focusFilterBtn() {
      this.$refs.filterBoxBtn.focus();
    },
    getAuditLogs() {
      let self = this;
      this.$store.dispatch("fetchAuditLogs").then(function(response) {
        
      }).catch(error => {
        toast.hide();
      });
    }
  },
  watch: {
    filterQuery: {
      handler: function(val, oldVal) {
        this.$store.commit('setAuditLogFilter', this.filterQuery)
        this.$store.dispatch("fetchAuditLogs");
        if (
          this.filterQuery.query == "" &&
          !this.filterQuery.filterByDateCreated &&
          !this.filterQuery.coordinator.length
        ) {
          $(".audit-log-wrapper").removeClass("hasFilter");
        } else {
          $(".audit-log-wrapper").addClass("hasFilter");
        }
      },
      deep: true
    }
  }
};
</script>

<style>
</style>